export const it_custom = {
    'capital_invested' : 'Capitale investito',
    'label_label': 'Etichetta',
    'label_price': 'Importo',
    'label_price_pay': 'Prezzo d\'acquisto',
    'label_income': 'Conto economico',
    'label_consumptive': 'Consuntivo',
    'await_building': 'Prima di compilare il conto economico, assicurati di aver inserito i dati della <strong>"scheda operazione"</strong>.',
    'await_todo': 'Prima di utilizzare la to do list, assicurati di aver inserito i dati della <strong>"scheda operazione"</strong>.',
    'label_add_cost' : 'Aggiungi costo',
    'label_list_cost' : 'Costi',
    'label_revenues': 'Ricavi',
    'label_add_resource_alert' : 'Prima di caricare una risorsa, inserisci un immobile',
    'label_add_resource': 'Nuova risorsa',
    'label_configuring': 'Configura questo CE',
    'label_modal_configure': 'CONFIGURATORE CE',
    'label_percentage_estate_worst_scenario': 'Scenario Peggiore',
    'label_percentage_estate_middle_scenario': 'Scenario Medio',
    'label_percentage_estate_better_scenario': 'Scenario Migliore',
    'label_percentage_estate_consumptive': 'Consuntivo',
    'label_template_list': 'Lista template',
    

    'popover_buildingData_title': 'La tua operazione',
    'popover_buildingData_content': '<p>Gestisci la scheda della tua operazione, modifica i dati, personalizza il tuo conto economico, inserisci il team di lavoro che opera sull\'operazione. Allega le foto e i documenti e compila la "To do List" e organizza le azioni da svolgere.</p>',

    'popover_income_title': 'Conto Economico',
    'popover_income_content': '<p>!Inserisci i valori e calcola in automatico del ROI e del ROE. Valuta lo scenario e stima i costi ed i ricavi dell\'operazione conclusa.\n' +
        '\n' +
        'Aggiungi o sottrai le righe e le descrizioni dei valori in base alle tue necessità e configura il tuo conto.</p>',

    'popover_resource_title': 'Risorse',
    'popover_resource_content': '<p>Allega i contenuti fotografici e tutta la documentazione utile allo svolgimento della tua operazione.\n</p>',


    'popover_incomefreeAgency_title': 'Agenzia Acquisto',
    'popover_incomefreeAgency_content': '<p>COSTO IMMOBILE(Acquisto) * Percentuale <hr> (Si può impostare la percentuale nel configuratore del conto economico).</p>',

    'popover_incomefreeAgencySell_title': 'Agenzia Vendita',
    'popover_incomefreeAgencySell_content': '<p>COSTO IMMOBILE(Vendita) * Percentuale <hr> (Si può impostare la percentuale nel configuratore del conto economico).</p>',

    'popover_incomefreeRegisterTax_title': 'Tassa Registro',
    'popover_incomefreeRegisterTax_content': '<p>1a Casa: (Rendita Catastale * 115.5 * 2) / 100 <br>' +
        '2a Casa: (Rendita Catastale * 126 * 9) / 100<br><br>' +
        '(La Rendita Catastale si può impostare nel configuratore del conto economico).</p>',


    'popover_incomefreeTotPurchase_title': 'Totale Costi Acquisto',
    'popover_incomefreeTotPurchase_content': '<p>E\' rappresentato dal totale dei costi.</p>',

    'popover_incomefreeSubstitutiveTax_title': 'Imposta sostitutiva',
    'popover_incomefreeSubstitutiveTax_content': '<p>VALORE FINANZIATO * Percentuale<hr> (Si può impostare la percentuale nel configuratore del conto economico).</p>',

    'popover_incomefreeTotalFinancingCost_title': 'Totale Costi Finanziamento',
    'popover_incomefreeTotalFinancingCost_content': '<p>E\' il totale del blocco "finanziamento" (escluso "Valore finanziato").</p>',

    'popover_incomefreeTotalCost_title': 'Totale Costi',
    'popover_incomefreeTotalCost_content': '<p>E\' la somma di "Totale Costi finanziamento" e del "Totale Costi di Acquisto".</p>',

    'popover_incomefreeTotalCostMQ_title': 'Totale Costi al MQ',
    'popover_incomefreeTotalCostMQ_content': '<p>"Totale Costi"  /  "Mq" dell\'immobile.</p>',

    'popover_incomefreeTotalCostMQTax_title': 'Totale Costi al MQ per tasse',
    'popover_incomefreeTotalCostMQTax_content': '<p>"Totale Costi di acquisto"  /  "Mq" dell\'immobile.</p>',

    'popover_incomefreeGrossProfit_title': 'Utile Lordo',
    'popover_incomefreeGrossProfit_content': '<p>"Totale ricavi"  -  "Totale Costi".</p>',

    'popover_incomefreeTotalTax_title': 'Totale Tasse',
    'popover_incomefreeTotalTax_content': '<p>"Utile Lordo"  *  "Percentuale 2a casa" <hr>(Si può impostare la percentuale nel configuratore del conto economico).</p>',

    'popover_incomefreeNetIncome_title': 'Utile Netto',
    'popover_incomefreeNetIncome_content': '<p>"Utile Lordo"  -  "Totale tasse" </p>',

    'popover_incomefreeROI_title': 'ROI',
    'popover_incomefreeROI_content': '<p>"Utile Lordo" / "Totale Costi" </p>',

    'popover_incomefreeROE_title': 'ROE',
    'popover_incomefreeROE_content': '<p>"Utile Netto" / "Capitale investito" </p>',
    
    'label_costi': 'COSTI',
    'label_acquisto': 'Acquisto',
    'label_atto_acquisto': 'Atto d\'acquisto',
    'label_agenzia_acquisto': 'Agenzia acquisto',
    'label_agenzia_vendita': 'Agenzia vendita',
    'label_tassa_registro': 'Tassa registro',
    'label_architetto': 'Architetto',
    'label_condono': 'Condono',
    'label_spese_condominiali': 'Spese condominiali',
    'label_fatture_luce': 'Nuove utenze luce/gas',
    'label_imprevisti': 'Imprevisti',
    'label_costo_ristrutturazione': 'Costo di ristrutturazione',
    'label_costo_totale_acquisto': 'Totale costi acquisto',
    'label_finanziamento': 'FINANZIAMENTO',
    'label_valore_finanziamento': 'Valore finanziato',
    'label_notaio' : 'Notaio ipoteca',
    'label_costi_gestione': 'Costi di gestione',
    'label_perito': 'Perito',
    'label_spesa_istruttoria': 'Spese istruttoria',
    'label_imposta_sostitutiva': 'Imposta sostitutiva',
    'label_assicurazione': 'Assicurazione',
    'label_interessi_mesi': 'Interessi mesi',
    'label_totale_costi_finanziamento': 'Totale costi finanziamento',
    'label_totale_costi': 'Totale costi',
    'label_totale_costi_mq': 'Costo totale MQ',
    'label_totale_costi_mq_tasse': 'Costo totale MQ per tasse',
    'label_ricavi': 'RICAVI (street price / m2',
    'label_totale_ricavi': 'Ricavi totali',
    'label_ricavi_mq': 'RICAVI MQ',
    'label_utile_lordo': 'Utile lordo',
    'label_tasse': 'TASSAZIONE',
    'label_totale_tasse': 'Totale tasse',
    'label_utile': 'UTILE',
    'label_utile_netto': 'Utile netto',
    'label_capitale_proprio_investito': 'Capitale proprio investito',
    'bottone_salva_scheda_operazione': 'SALVA SCHEDA OPERAZIONE',
}
